import { render, staticRenderFns } from "./NumberStatus.vue?vue&type=template&id=396410f8&scoped=true&"
import script from "./NumberStatus.vue?vue&type=script&lang=js&"
export * from "./NumberStatus.vue?vue&type=script&lang=js&"
import style0 from "./NumberStatus.vue?vue&type=style&index=0&id=396410f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396410f8",
  null
  
)

export default component.exports